// extracted by mini-css-extract-plugin
module.exports = {"HWCard":"HWCard_HWCard__1i2zd"};